import Carousel from 'react-bootstrap/Carousel';
import './Carousel.css';
import Card00 from '../cards/Card00';
import Card01 from '../cards/Card01';
import MissionStatement from '../mainpagelinks/aboutus/MissionStatement'

function DarkVariantExample() {
  return (
    <>
    <Carousel data-bs-theme="dark" className="carousel-container">
      <Carousel.Item interval={1000}> {/* 2 seconds */}
        <img
          className="d-block w-100"
          src="/carousel/carousel01.jpeg"
          alt="First slide"
          style={{ height: '400px', objectFit: 'cover' }}
        />
        <Carousel.Caption>
          <h1>Empowering Minds Through Education</h1>
          <p>Empowering Minds Through Education</p>
        </Carousel.Caption>
      </Carousel.Item>

       <Carousel.Item interval={1000}> {/* 2 seconds */}
        <img
          className="d-block w-100"
          src="/carousel/carousel02.jpeg"
          alt="Second slide"
          style={{ height: '400px', objectFit: 'cover' }}
        />
        <Carousel.Caption>
          <h1>Learn today, lead tomorrow.</h1>
          <p>Empowering Minds Through Education</p>
        </Carousel.Caption>
      </Carousel.Item>

      <Carousel.Item interval={1000}> {/* 2 seconds */}
        <img
          className="d-block w-100"
           src="/carousel/carousel03.jpeg"
          alt="Third slide"
          style={{ height: '400px', objectFit: 'cover' }}
        />
        <Carousel.Caption>
         <h1>Empowering Minds Through Education</h1>
          <p>Empowering Minds Through Education</p>
        </Carousel.Caption>
      </Carousel.Item>


       <Carousel.Item interval={1000}> {/* 2 seconds */}
        <img
          className="d-block w-100"
           src="/carousel/carousel04.jpeg"
          alt="Third slide"
          style={{ height: '400px', objectFit: 'cover' }}
        />
        <Carousel.Caption>
          <h1>Committed to learning, dedicated to success.</h1>
          <p>Empowering Minds Through Education</p>
        </Carousel.Caption>
      </Carousel.Item>

      <Carousel.Item interval={1000}> {/* 2 seconds */}
        <img
          className="d-block w-100"
           src="/carousel/carousel05.jpeg"
          alt="Third slide"
          style={{ height: '400px', objectFit: 'cover' }}
        />
        <Carousel.Caption>
       <h1>Exploring ideas, expanding minds.</h1>
          <p>Empowering Minds Through Education</p>
        </Carousel.Caption>
      </Carousel.Item>

    </Carousel>
     <Card00 />
    <Card01 />
      
</>
  );
}

export default DarkVariantExample;
